import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DataTypeBoolean = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M21 11.167H11a4.833 4.833 0 1 0 0 9.666h10a4.833 4.833 0 1 0 0-9.666ZM11 10a6 6 0 0 0 0 12h10a6 6 0 0 0 0-12H11Z"
		/>
		<path d="M15 16a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" />
	</svg>
);

export default DataTypeBoolean;
